import {TICKET_SERVER} from "@/api/server.js";
import {athubAxios} from "@/util/athub-axios/index.js";
import axios from 'axios';


// TICKET 查询待接单监控接入告警主键编号

//分页查询
function page(param) {
    let url = `${TICKET_SERVER}/tickets`;
    return new Promise((resolve, reject) => {
        athubAxios.postByMultipartForm(url, param, {'loading': false}).then(responseBody => {
        if (responseBody.data.code === 200) {
        resolve(responseBody.data);
    } else {
        reject(responseBody.data.message);
    }
}).catch(error => {
        reject(error);
});
});
};


//事件类型查询
function queryTicketType() {
    let url = `${TICKET_SERVER}/getTicketType`;
    return new Promise((resolve, reject) => {
        athubAxios.postByJson(url, null).then(responseBody => {
        if (responseBody.data.code == 200) {
        resolve(responseBody.data.data);
        } else {
            reject(responseBody.data.message);
        }
}).catch(error => {
        reject(error);
});
});
};





//故障类型查询
function queryFailuretypes(tickettype) {
    let url = `${TICKET_SERVER}/ticket/getFailureInfo/`+tickettype+`?appId=WEB&token=`+localStorage.getItem("toekn");
    return new Promise((resolve, reject) => {
        athubAxios.get(url, null).then(responseBody => {
        if (responseBody.data.code == 200) {
        resolve(responseBody.data.failureList);
    } else {
        reject(responseBody.data.message);
    }
}).catch(error => {
        reject(error);
});
});
};




//故障现象查询
function queryFailurecodes(failuretype) {
    let url = `${TICKET_SERVER}/ticket/getProblemByFailureCode/`+failuretype+`?appId=WEB&token=`+localStorage.getItem("toekn");
    return new Promise((resolve, reject) => {
        athubAxios.get(url, null).then(responseBody => {

        if (responseBody.data.code == 200) {
        resolve(responseBody.data.failureList);
    } else {
        reject(responseBody.data.message);
    }
}).catch(error => {
        reject(error);
});
});
};




//问题代码查询
function queryProblemcodes(failurecode) {
    let url = `${TICKET_SERVER}/ticket/getReasonByProblemCode/`+failurecode+`?appId=WEB&token=`+localStorage.getItem("toekn");
    return new Promise((resolve, reject) => {
            athubAxios.get(url, null).then(responseBody => {

    if (responseBody.data.code == 200) {
        resolve(responseBody.data.failureList);
    } else {
        reject(responseBody.data.message);
    }
}).catch(error => {
        reject(error);
});
});
};



//草稿发送工作流调用ticket后台接口
function draftSendWorkFlow(url, param) {
    let urlRequest = `${TICKET_SERVER}` + url;
    return new Promise((resolve, reject) => {
        athubAxios.postByJson(urlRequest, param).then(responseBody => {
            if (responseBody.data.code == 200) {
                resolve(responseBody.data.message);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};


//待接单接单发送工作流调用 ticket后台接口
function draftReceivingOrders(url,param){
    let urlRequest = `${TICKET_SERVER}`+url;
    return new Promise((resolve, reject) => {
            athubAxios.postByJson(urlRequest, param).then(responseBody => {
            if (responseBody.data.code == 200) {
        resolve(responseBody.data);
    } else {
        resolve(responseBody.data);
    }
}).catch(error => {
        reject(error);
});
});
}



//查询事件详情对应的流转信息
function queryProcessInfos(url){
    let urlRequest = `${TICKET_SERVER}`+url;
    return new Promise((resolve, reject) => {
            athubAxios.get(urlRequest, null).then(responseBody => {
            if (responseBody.data.code == 200) {
        resolve(responseBody.data);
    } else {
        reject(responseBody.data.message);
    }
}).catch(error => {
        reject(error);
});
});
}



//草稿发送工作流调用ticket后台接口
function draftSendWorkFlowForm(url,param) {
    let urlRequest = `${TICKET_SERVER}`+url;
    return new Promise((resolve, reject) => {
            axios.post(urlRequest, param).then(responseBody => {
            if (responseBody.data.code == 200) {
        resolve(responseBody.data);
    } else {
        resolve(responseBody.data);
    }
}).catch(error => {
        reject(error);
});
});
};




//加载待处理保存得时候选择得创建人和处理人
function queryTicketEvalList(url){
    let urlRequest = `${TICKET_SERVER}`+url;
    return new Promise((resolve, reject) => {
            athubAxios.get(urlRequest, null).then(responseBody => {
            if (responseBody.data.code == 200) {
        resolve(responseBody.data);
    } else {
        reject(responseBody.data.message);
    }
}).catch(error => {
        reject(error);
});
});
}


//验当前ticket是否有数据报告
function queryEventReportHas(url){
    let urlRequest = `${TICKET_SERVER}`+url;
    return new Promise((resolve, reject) => {
            athubAxios.get(urlRequest, null).then(responseBody => {
            if (responseBody.data.code == 200) {
        resolve(responseBody.data);
    } else {
        reject(responseBody.data.message);
    }
}).catch(error => {
        reject(error);
});
});
}



//制作事件报告
function makeReport(url,param){
    let urlRequest = `${TICKET_SERVER}`+url;
    return new Promise((resolve, reject) => {
            athubAxios.postByForm(urlRequest, param).then(responseBody => {
            if (responseBody.data.code == 200) {
        resolve(responseBody.data);
    } else {
        reject(responseBody.data.message);
    }
}).catch(error => {
        reject(error);
});
});
}



//导出
function exportExcel(param){
    return new Promise((resolve, reject) => {
            athubAxios.postByForm(`${TICKET_SERVER}/ticket/excel`, param,{responseType:'blob',timeout:1000000}).then(responseBody => {
            
            if (responseBody.status == 200) {
        //获取返回的流并且赋值blob
        let blob = responseBody.data;
        let reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
            var a = document.createElement('a');
            a.download = '事件列表_' + new Date().Format("yyyy-MM-dd hh-mm-ss") + '.xlsx';
            a.href = e.target.result;
            $("body").append(a);
            a.click();
            $(a).remove();
        }
        resolve(responseBody);
    }

}).catch(error => {

    });
});
}



//判断当前事件状态和数据库是否一致
function queryStatusByInfo(data) {
    let url = `${TICKET_SERVER}/queryStatusByInfo`;
    return new Promise((resolve, reject) => {
            athubAxios.postByJson(url, data).then(responseBody => {
            if (responseBody.data.code == 200) {
        resolve(responseBody.data.data);
    } else {
        reject(responseBody.data.message);
    }
}).catch(error => {
        reject(error);
});
});
};


export {
    page,
    queryTicketType,
    queryFailuretypes,
    queryFailurecodes,
    queryProblemcodes,
    draftSendWorkFlow,
    draftReceivingOrders,
    queryProcessInfos,
    draftSendWorkFlowForm,
    queryTicketEvalList,
    queryEventReportHas,
    makeReport,
    exportExcel,
    queryStatusByInfo,
}
